export default function Partners() {
	return <p>Partners</p>;
}